import React, { useEffect, useState } from "react";
import "./BlockedUser.css";
import { getBlockedUsers } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import Pagination from "../pagination";
import { toast } from "react-toastify";
import AddNewBlockUser from "./AddBlockUser";
import DataTable from "../../../components/common/DataTable/DataTable";
import CopyCell from "../../../components/common/TableCells/CopyCell";
import Spinner from "../../Spin/Spinner";

const BlockedUserPage = () => {
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const token = useSelector((state) => state.userReducer.token);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const fetchBlockedUsers = async (currentPage, searchTerm) => {
    try {
      setLoading(true);
      const response = await getBlockedUsers(currentPage, searchTerm);
      setBlockedUsers(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Unable to fetch blocked users.");
    }
  };

  useEffect(() => {
    if (searchTerm !== "") {
      const delayDebounce = setTimeout(() => {
        fetchBlockedUsers(1, searchTerm);
      }, 2000);

      return () => clearTimeout(delayDebounce);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchBlockedUsers(currentPage, "");
    }
  }, [currentPage, searchTerm]);

  const columns = [
    {
      key: "name",
      header: "Payer Name",
      wrapCell: true,
    },
    {
      key: "email",
      header: "Payer Email",
      wrapCell: true,
    },
    {
      key: "phoneNumber",
      header: "Payer Phone",
    },
    {
      key: "vpa",
      header: "Request VPA",
      wrapCell: true,
      render: (row) => <CopyCell value={row.vpa} />,
    },
    {
      key: "responseVpa",
      header: "Response VPA",
      wrapCell: true,
      render: (row) => <CopyCell value={row.responseVpa} />,
    },
    {
      key: "date",
      header: "Date",
      wrapCell: true,
    },
  ];

  const formattedData =
    blockedUsers?.map((item) => ({
      name: item?.name || "-",
      email: item?.email || "-",
      phoneNumber: item?.phoneNumber || "-",
      vpa: item?.vpa || "-",
      responseVpa: item?.responseVpa || "-",
      date: item?.updatedAt
        ? new Date(item.updatedAt).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })
        : "-",
    })) || [];

  return (
    <div className="blocked-status-table-container">
      <div className="block-key-add">
        <div className="blocked-status-heading">
          <h2 className="blocked-status-table-title">Blocked User</h2>
          <input
            className="blocked-input-field-container"
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div>
          <button
            className="keyword-add-button"
            onClick={() => setIsAddModalOpen(true)}
          >
            Add +
          </button>
        </div>
      </div>
      <div>
        {loading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={formattedData}
            emptyMessage="No data found."
          />
        )}
      </div>
      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
      {isAddModalOpen && (
        <AddNewBlockUser onClose={() => setIsAddModalOpen(false)} />
      )}
    </div>
  );
};

export default BlockedUserPage;
